var React = require('react');

function DropdownArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M.086 3.02a.292.292 0 0 1 0-.412l.413-.413a.292.292 0 0 1 .412 0L3.5 4.785l2.589-2.59a.292.292 0 0 1 .412 0l.413.413a.292.292 0 0 1 0 .412L3.707 6.227a.29.29 0 0 1-.207.086.29.29 0 0 1-.207-.086L.086 3.02z","fill":"#502314"}));
}

DropdownArrow.defaultProps = {"width":"7","height":"8","viewBox":"0 0 7 8","fill":"none"};

module.exports = DropdownArrow;

DropdownArrow.default = DropdownArrow;
